interface ProjectCount {
  total: number
  lead: number
  // May be absent while the frontend deploys ahead of the backend.
  projects?: number
  active: number
  archived: number
}

interface Customer {
  id: string
  first_name: string
  middle_name: string | null
  last_name: string
  email: string
  phone: string
  notes: string | null
  status: string // можеш уточнити enum якщо знаєш всі статуси
  is_deleted?: boolean
  registered_at: string
  created: string
  updated: string
  address: string
  zip_code: string
  city: string
  address_2: string | null
  state: string | null
  phone_2: string | null
  phone_3: string | null
  project_count: ProjectCount
}

type CustomerEditableField =
  | "first_name"
  | "middle_name"
  | "last_name"
  | "email"
  | "phone"
  | "phone_2"
  | "phone_3"
  | "notes"
  | "address"
  | "address_2"
  | "city"
  | "state"
  | "zip_code"

interface CustomerMutateData extends Partial<
  Record<CustomerEditableField, string | null>
> {
  is_invite?: boolean
}

interface CustomerSearchResult {
  // Added by the current backend; optional keeps rolling deploys compatible.
  id?: string | null
  email: string | null
  first_name: string | null
  middle_name: string | null
  last_name: string | null
  phone: string | null
  phone_2: string | null
  phone_3: string | null
  address: string | null
  address_2: string | null
  city: string | null
  state: string | null
  zip_code: string | null
  status: string | null
  // Absent on an older backend, so a missing flag has to read as "not suspended".
  is_suspended?: boolean | null
}

interface CustomerNameMatch {
  id: string
  first_name: string | null
  middle_name: string | null
  last_name: string | null
  email: string | null
  phone: string | null
  is_incomplete: boolean
  project_count: number
  is_suspended?: boolean | null
}

enum EmailModalStateAction {
  invite,
  resend_invite,
  suspend
}

interface EmailModalState {
  customer: Customer | null
  action: EmailModalStateAction
  helperText?: string
}

export type {
  Customer,
  CustomerEditableField,
  CustomerMutateData,
  EmailModalState,
  CustomerSearchResult,
  CustomerNameMatch
}

export { EmailModalStateAction }
